import { HateoasResource, Resource } from '@lagoshny/ngx-hateoas-client';

@HateoasResource('ipsecShares', { routeName: 'frontdoorResourceRoute' })
export class IpsecShare extends Resource {
    id: string;
    name: string;
    frontdoorId: string;
    locationId: string;
    ipsecTunnelId: string;
    status: string;
    hostingId: string;
    zId: string;
    envZId: string;
    target: string;
    ingressPort: number;
    frontendEndpoint: string;
    createdAt: string;
    updatedAt: string;
    selected = false;
}
